import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AnalyticsPlugin } from '@plugins/analytics/analytics-plugin';
import { DashboardFeedItemUpcomingJobs } from '@bluecrew/crew-member-backend-angular-client';
import { ActiveDays } from 'src/app/common/working-days-of-week/working-days-of-week.component';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';

@Component({
  selector: 'app-upcoming-jobs',
  templateUrl: './upcoming-jobs.component.html',
  styleUrls: ['./upcoming-jobs.component.scss']
})
export class UpcomingJobsComponent {

  nextShift;
  private _feedItem: DashboardFeedItemUpcomingJobs;
  private days: ActiveDays = {};
  private workDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  @Input() showPositionUpdatesButton: boolean = false;
  @Input()
  get feedItem(): DashboardFeedItemUpcomingJobs {
      return this._feedItem;
  }
  set feedItem(feedItem: DashboardFeedItemUpcomingJobs) {
    this._feedItem = feedItem;
    this.nextShift = this._feedItem.nextShift;
    let dayOrder = [];
    const startDay = new Date().getDay();

    // Sets the day order with index 0 being today's day of the week 
    // and index 6 being yesterday's day of the week. For example, if today
    // is Tuesday, it would look like ['tuesday' ... 'monday']
    for (let i = startDay; i < startDay + this.workDays.length; i++) {
      dayOrder.push(this.workDays[i % this.workDays.length]);
    }
    
    // Set the boolean value for each day in the ActiveDays object
    for (let i = 0; i < dayOrder.length; i++) {
      this.days[dayOrder[i]] = this._feedItem.workDays[i];
    }
  }
  
  constructor(private navCtrl: NavController) { }

  fallbackWorkplaceImg = ($event: ErrorEvent) => {
    ($event.target as HTMLImageElement).src = '/assets/icons/building.svg';
  };

  async onClick() {
    AnalyticsPlugin.logEvent({
      name: 'upcomingJobsCard_open_schedule',
      params: {}
    });
    await this.navCtrl.navigateForward(AppRoutingUtil.SCHEDULE);
  }
}
